module.exports = __webpack_public_path__ + "static/media/logo.356a21b2.png";